import { cases as listCases } from './list'

export default {
  ...listCases
}
